// extracted by mini-css-extract-plugin
export var callCard = "_sk-0";
export var callMessageButton = "_sk-1";
export var helpIcon = "_sk-3";
export var helpIconContainer = "_sk-4";
export var verticalDivider = "_sk-2";